import { render, staticRenderFns } from "./MailPOSBizTopic.vue?vue&type=template&id=a988074e&lang=pug"
import script from "./MailPOSBizTopic.vue?vue&type=script&lang=js"
export * from "./MailPOSBizTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports